import { gql } from 'graphql-request';

export const CREW_FIELDS = gql`
  fragment CrewFields on CrewDto {
    crewId
    name
    employees {
      employeeId
      rate
      hireDate
      dob
      payPeriod
      user {
        firstName
        lastName
        avatar
        email
        userId
        role
      }
    }
    tasks {
      projectId
      project {
        siteImage
        projectId
        name
      }
      taskId
      name
      startTime
      endTime
      projectId
      status
      parentTaskId
    }
  }
`;

export const getCrews = gql`
  query getCrews {
    getCrews {
      ...CrewFields
    }
  }

  ${CREW_FIELDS}
`;

export const getCrewsByUser = gql`
  query getCrewsByUser($userId: String) {
    getCrewsByUser(userId: $userId) {
      ...CrewFields
    }
  }

  ${CREW_FIELDS}
`;

export const createCrew = gql`
  mutation createCrew($crew: CrewCreateInput!) {
    createCrew(crew: $crew) {
      ...CrewFields
    }
  }
  ${CREW_FIELDS}
`;

export const updateCrew = gql`
  mutation updateCrew($crew: CrewUpdateInput!) {
    updateCrew(crew: $crew) {
      ...CrewFields
    }
  }
  ${CREW_FIELDS}
`;

export const deleteCrew = gql`
  mutation deleteCrew($id: String!) {
    deleteCrew(id: $id) {
      affected
      messages
    }
  }
`;

export const getCrewById = gql`
  query GetCrewById($id: String!) {
    getCrewById(id: $id) {
      ...CrewFields
    }
  }
  ${CREW_FIELDS}
`;

export const assignEmployeesToCrew = gql`
  mutation assignEmployeesToCrew($crewId: String!, $employeeIds: [String!]!) {
    assignEmployeesToCrew(crewId: $crewId, employeeIds: $employeeIds) {
      crewId
      name
      employees {
        employeeId
        rate
        hireDate
        dob
        payPeriod
        user {
          firstName
          lastName
          avatar
          email
          userId
        }
      }
    }
  }
`;

export const unassignEmployee = gql`
  mutation unassignEmployee($crewId: String!, $employeeId: String!) {
    unassignEmployee(crewId: $crewId, employeeId: $employeeId) {
      crewId
      name
    }
  }
`;

/**
 * Every task in the organization the crew-assignment modal can offer, with just
 * enough of each task to render its assignment state. Delegated tasks come back
 * too — the modal shows them locked rather than hiding them.
 */
export const getAssignableTasks = gql`
  query getAssignableTasks($projectIds: [String!], $includeCompleted: Boolean) {
    getAssignableTasks(
      projectIds: $projectIds
      includeCompleted: $includeCompleted
    ) {
      taskId
      name
      status
      startTime
      endTime
      manHours
      parentTaskId
      projectId
      project {
        projectId
        name
      }
      crews {
        crewId
        name
      }
      delegateOrganizationId
      delegateOrganization {
        organizationId
        name
      }
    }
  }
`;

export const assignTasksToCrew = gql`
  mutation assignTasksToCrew($crewId: String!, $taskIds: [String!]!) {
    assignTasksToCrew(crewId: $crewId, taskIds: $taskIds) {
      ...CrewFields
    }
  }
  ${CREW_FIELDS}
`;

const CrewsGraphQL = {
  queries: {
    getCrews,
    getCrewsByUser,
    getCrewById,
    getAssignableTasks,
  },
  mutations: {
    createCrew,
    updateCrew,
    deleteCrew,
    assignEmployeesToCrew,
    assignTasksToCrew,
    unassignEmployee,
  },
};

export default CrewsGraphQL;
